import React, { createContext, useState, useContext } from "react";
import { log } from '../Assets/enviorement';

// Create a context for user information
export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    email: "",
    firstName: "",
    lastName: "",
    address: "",
    apartment: "",
    city: "",
    state: "",
    zipCode: "",
    phone: "",
  });

  const updateUser = (newUserData) => {
    setUser((prevState) => {
      const updatedUser = {
        ...prevState,
        ...newUserData,
      };
      log(" User Data:", updatedUser); // Log the updated user data
      return updatedUser;
    });
  };

  return (
    <UserContext.Provider value={{ user, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
